<script setup lang="ts">
  import { PropType } from 'vue'
  import { capitalize } from '@/helpers/converter'
  import { ICharacterCdn } from '@/store/ClassesJobs'

  const stats = ['attack', 'defense', 'mobility', 'difficulty']
  const props = defineProps({
    characterData: {
      type: Object as PropType<ICharacterCdn>,
      required: true,
    },
  })
</script>
<template>
  <div class="stats" :class="{ 'has-note': !!characterData.note }">
    <div v-for="stat in stats" :key="stat">
      <div class="stat-icon"><div :class="`${stat}`"></div></div>
      {{ capitalize(stat) }}
      <div class="graph">
        <div
          :style="{
            right: `${100 - ((props.characterData && characterData[stat]) || 0)}%`,
          }"
        ></div>
      </div>
    </div>
    <div v-if="!!characterData.note" class="note">
      {{ characterData.note }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
  $imgPath: '@/assets/imgs/classesJobs';
  .stats {
    display: flex;
    flex-direction: column;
    margin-top: pxToRem(25px);
    > div {
      height: pxToRem(41.325px);
      background: url(#{$imgPath}/stats/bg.png) no-repeat center center / 100% auto;
      width: pxToRem(435px);
      margin: pxToRem(20.825px) auto 0;
      display: flex;
      align-items: center;
      color: #fff;
      font-family: Glegoo;
      font-size: pxToRem(16.125px);
      font-weight: bold;
      position: relative;
    }
    .stat-icon {
      width: pxToRem(39.8px);
      height: 100%;
      margin-left: pxToRem(5px);
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        background-repeat: no-repeat;
        background-size: 100% auto;
        &.attack {
          background-image: url(#{$imgPath}/stats/icons/attack.png);
          width: pxToRem(21.15px);
          height: pxToRem(20.25px);
        }
        &.defense {
          background-image: url(#{$imgPath}/stats/icons/defense.png);
          width: pxToRem(20.175px);
          height: pxToRem(20.925px);
        }
        &.mobility {
          background-image: url(#{$imgPath}/stats/icons/mobility.png);
          width: pxToRem(22.975px);
          height: pxToRem(22.75px);
        }
        &.difficulty {
          background-image: url(#{$imgPath}/stats/icons/difficulty.png);
          width: pxToRem(25.375px);
          height: pxToRem(12.325px);
        }
      }
    }
    .graph {
      height: pxToRem(27.225px);
      width: pxToRem(287.3px);
      background: url(#{$imgPath}/stats/graph_bg.png) no-repeat center center / auto 100%;
      position: absolute;
      right: pxToRem(12.5px);
      overflow: hidden;
      > div {
        height: 100%;
        width: 100%;
        background: url(#{$imgPath}/stats/fill.png) no-repeat center center / auto 100%;
        position: absolute;
        right: 100%;
        transition: all 0.5s linear;
      }
    }
    .note {
      color: #5a5753;
      font-size: pxToRem(16px);
      line-height: 1.5em;
      background: none;
    }
    &.has-note {
      margin-top: 0;
    }
  }

  @media #{$tablet} {
    div.stats {
      margin: 0;
      > div {
        height: pxToRemTablet(41.002px);
        width: pxToRemTablet(422.18px);
        font-size: pxToRemTablet(15.998px);
        margin: 0;
        &:not(:first-child) {
          margin: pxToRemTablet(19px) auto 0;
        }
      }
      .stat-icon {
        width: pxToRemTablet(38px);
        margin: 0;
        > div {
          &.attack {
            width: pxToRemTablet(20.976px);
            height: pxToRemTablet(19.874px);
          }
          &.defense {
            width: pxToRemTablet(20.026px);
            height: pxToRemTablet(20.748px);
          }
          &.mobility {
            width: pxToRemTablet(22.8px);
            height: pxToRemTablet(22.572px);
          }
          &.difficulty {
            width: pxToRemTablet(25.156px);
            height: pxToRemTablet(12.236px);
          }
        }
      }
      .graph {
        height: pxToRemTablet(27.018px);
        width: pxToRemTablet(285px);
        right: pxToRemTablet(7.6px);
      }
      .note {
        font-size: pxToRemTablet(14px);
      }
    }
  }

  @media #{$mobile} {
    div.stats {
      margin-top: pxToRemMobile(9px);
      > div {
        height: pxToRemMobile(41.994px);
        width: pxToRemMobile(432px);
        font-size: pxToRemMobile(16.002px);
        &:not(:first-child) {
          margin: pxToRemMobile(20.7px) auto 0;
        }
      }
      .stat-icon {
        width: pxToRemMobile(36px);
        margin-left: pxToRemMobile(4.5px);
        > div {
          &.attack {
            width: pxToRemMobile(20.898px);
            height: pxToRemMobile(20.25px);
          }
          &.defense {
            width: pxToRemMobile(19.944px);
            height: pxToRemMobile(20.916px);
          }
          &.mobility {
            width: pxToRemMobile(22.716px);
            height: pxToRemMobile(22.734px);
          }
          &.difficulty {
            width: pxToRemMobile(25.092px);
            height: pxToRemMobile(12.312px);
          }
        }
      }
      .graph {
        height: pxToRemMobile(28.206px);
        width: pxToRemMobile(297.99px);
        right: pxToRemMobile(9px);
      }
      .note {
        font-size: pxToRemMobile(14px);
      }
    }
  }
</style>
